import * as THREE from 'three';
import { loadUserHeightCm } from '../setup/heightPanel';
import {
  PANEL_CENTER_Y_FACTOR,
  PANEL_DIST_M,
  PANEL_MIN_CENTER_Y_M,
  PELL_AUTO_DISTANCE_M,
} from '../config/constants';

/**
 * Place a panel mesh in front of the user at a uniform distance and at a Y
 * derived from the user's configured height — consistent across wizard,
 * pause, summary, and settings panels.
 */
export function placePanelInFront(mesh: THREE.Object3D, camera: THREE.Camera): void {
  const camPos = new THREE.Vector3();
  camera.getWorldPosition(camPos);

  const forward = new THREE.Vector3();
  camera.getWorldDirection(forward);
  forward.y = 0;
  if (forward.lengthSq() < 1e-4) forward.set(0, 0, -1);
  forward.normalize();

  const centerY = computePanelCenterY();

  mesh.position.set(
    camPos.x + forward.x * PANEL_DIST_M,
    centerY,
    camPos.z + forward.z * PANEL_DIST_M,
  );
  mesh.lookAt(new THREE.Vector3(camPos.x, centerY, camPos.z));
}

/** Y center for all UI panels, derived from stored user height. */
export function computePanelCenterY(): number {
  const heightM = loadUserHeightCm() / 100;
  return Math.max(PANEL_MIN_CENTER_Y_M, heightM * PANEL_CENTER_Y_FACTOR);
}

/**
 * Compute where to spawn the pell at session start: a fixed distance in front
 * of the user along the camera's horizontal forward, grounded at y=0.
 */
export function computePellAutoPosition(camera: THREE.Camera): THREE.Vector3 {
  const camPos = new THREE.Vector3();
  camera.getWorldPosition(camPos);

  const forward = new THREE.Vector3();
  camera.getWorldDirection(forward);
  forward.y = 0;
  if (forward.lengthSq() < 1e-4) forward.set(0, 0, -1);
  forward.normalize();

  return new THREE.Vector3(
    camPos.x + forward.x * PELL_AUTO_DISTANCE_M,
    0,
    camPos.z + forward.z * PELL_AUTO_DISTANCE_M,
  );
}
